import { IconProps, Icons } from './IconsRes';
import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { getIconClasses } from './IconUtils';

export const FolderIcon = ({ id, onClick, className, size = 'small', disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Folder}
      className={cn(styles.icon, styles.button, getIconClasses(size), className)}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
